import React from 'react'
import { useTranslation } from 'react-i18next'
import { clearItemFromSessionStorage, setToSessionStorage } from '../../utils/StorageUtils'
import plusIcon from '../../assets/images/plus.svg'
import infoIcon from '../../assets/images/sccInfo.svg'
const RecommendedSccList = ({
	recommendedSccs,
	handleAddAdditinalScc,
	services,
	showWarning,
	className
}) => {
	const { t, i18n } = useTranslation(['labels'])
	console.log()

	return recommendedSccs && recommendedSccs.length ? (
		<div class={`cargo-scc-recommendation-row ${className || ''}`}>
			{recommendedSccs && recommendedSccs.length ? (
				recommendedSccs.map((scc, index) => {
					const service =
						services &&
						services.length &&
						services.find((service) => service.scc === scc)
					const upsellOffered = service ? `${service.name} [${scc}]` : scc
					setToSessionStorage('upsellOffered', upsellOffered)
					return (
						<>
							<label className='scc-recom-label'>{t('BOOKING.WE_RECOMMEND')}</label>
							<span
								key={`apld-${index}`}
								onClick={() => {
									showWarning()
									handleAddAdditinalScc({
										scc: service.scc,
										sccDescription: service.name,
									})
								}}
								className='scccode'
							>
								<div className='scc-left'>
									<img className='scc-plus' src={plusIcon} alt='plus' title='plus-scc' />
									{upsellOffered}
								</div>
								<div className='scc-right'>
									<img className='scc-info' src={infoIcon} alt='info' title='info-scc' />
									<div>
										{service?.description || `Service name is ${service.name}, scc is ${service.scc} and product is ${service.product}.`}
										<span className="scc-info-link ml-1" onClick={(e) => { e.stopPropagation(); window.open(service?.refUrl || 'https://www.etihadcargo.com') }}>Learn more</span>
									</div>
								</div>
							</span>
						</>
					)
				})
			) : (
				<></>
			)}
		</div>
	) : (
		<></>
	)
}

export default RecommendedSccList
